const emailToUsername = (email: string): string => {
  const arrobaIndex = email.indexOf('@')

  const length = arrobaIndex === -1 ? email.length : arrobaIndex

  const username = email.substring(0, length)

  return username
}
export default emailToUsername
